import { render, staticRenderFns } from "./NominacionRegaliasModal.vue?vue&type=template&id=78fcbf69"
import script from "./NominacionRegaliasModal.vue?vue&type=script&lang=js"
export * from "./NominacionRegaliasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports